export interface CreateBespokeRatingValues {
  bankingGroupId: number
  startDate: Date | string
  maxLimitShort: number
  maxLimitLong: number
  maxMoneyLimitShort: number
  maxMoneyLimitLong: number
}

export const createBespokeRatingInitialValues: CreateBespokeRatingValues = {
  bankingGroupId: 0,
  startDate: null,
  maxLimitShort: 0,
  maxLimitLong: 0,
  maxMoneyLimitShort: 0,
  maxMoneyLimitLong: 0,
}
